var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex flex-row justify-sm-center flex-nowrap",staticStyle:{"overflow-x":"auto"},attrs:{"tile":"","elevation":"0","outlined":"","color":"secondary"}},_vm._l((_vm.getGroups),function(group,index){return _c('GroupItem',{key:index,attrs:{"group":group},on:{"select":_vm.onGroupItemSelect}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }